/**
 * SNIPPET - ITEM PRODUCT - LISTENERS
 */

setupEventListenersForProductsItems();

// Creates the event listeners
function setupEventListenersForProductsItems() {
  // On clicking on the add to cart button in a product item
  document.querySelectorAll('[data-action="add-to-cart-product-item"]').forEach((element) => {
    element.addEventListener('click', clickProductItemAddToCartHandler);
  });
  
  // On clicking on the add to cart button in a bundle product item
  document.querySelectorAll('[data-action="add-to-cart-product-item-bundle"]').forEach((element) => {
    element.addEventListener('click', clickProductItemBundleAddToCartHandler);
  });
  
  // On clicking on an add to cart button under a products list
  document.querySelectorAll('[data-action="add-to-cart-products-list"]').forEach((element) => {
    element.addEventListener('click', clickProductsListAddToCartHandler);
  });
  
  // On clicking on an add to cart button at the end of the products selector
  document.querySelectorAll('[data-action="add-to-cart-products-selector"]').forEach((element) => {
    element.addEventListener('click', clickProductsSelectorAddToCartHandler);
  });
  
  // On clicking on an add to cart button at the end of the bundle builder
  document.querySelectorAll('[data-action="add-to-cart-bundle-builder"]').forEach((element) => {
    element.addEventListener('click', clickBundleBuilderAddToCartHandler);
  });
  
  // On clicking on a product bundle item not in the bundle builder
  document.querySelectorAll('[data-item-action="select-bundle-in-collection"]').forEach((element) => {
    element.addEventListener('click', clickItemBundleInCollectionHandler);
  });
  
  // On clicking on a product bundle item in the bundle builder
  document.querySelectorAll('[data-item-action="select-bundle-in-builder"]').forEach((element) => {
    element.addEventListener('click', clickItemBundleInBuilderHandler);
  });
  
  // On clicking the - button of the quantity in a product selector item in the default context
  document.querySelectorAll('.item-product-2 .quantity-selector[data-context="default"] [data-action="sub-product"]').forEach((element) => {
    element.addEventListener('click', clickProductItemSubQuantityHandler);
  });
  
  // On clicking the + button of the quantity in a product selector item in the default context
  document.querySelectorAll('.item-product-2 .quantity-selector[data-context="default"] [data-action="add-product"]').forEach((element) => {
    element.addEventListener('click', clickProductItemAddQuantityHandler);
  });
  
  // On clicking on the - button of the quantity in a product selector item in the bundle builder context
  document.querySelectorAll('.item-product-2 .quantity-selector[data-context="bundle-builder"] [data-action="sub-product"]').forEach((element) => {
    element.addEventListener('click', clickProductItemBundleBuilderSubQuantityHandler);
  });
  
  // On clicking on the + button of the quantity in a product selector item in the bundle builder context
  document.querySelectorAll('.item-product-2 .quantity-selector[data-context="bundle-builder"] [data-action="add-product"]').forEach((element) => {
    element.addEventListener('click', clickProductItemBundleBuilderAddQuantityHandler);
  });
  
  // On clicking on the "Add" button in a product selector item where you can select several products
  document.querySelectorAll('.item-product-2 [data-action="show-product-quantity"]').forEach((element) => {
    element.addEventListener('click', clickShowProductQuantityHandler);
  });
  
  // On clicking on the "Add" button in a product selector item where you can only select one product
  document.querySelectorAll('.item-product-2 [data-action="select-product"]').forEach((element) => {
    element.addEventListener('click', clickSelectProductHandler);
  });
}

/**
 * SNIPPET - ITEM PRODUCT - GENERAL
 */

// On clicking on the add to cart button in a product item
function clickProductItemAddToCartHandler() {
  event.preventDefault();
  addToCartFromProductItem();
}

// On clicking on the add to cart button in a bundle product item
function clickProductItemBundleAddToCartHandler() {
  event.preventDefault();
  addToCartFromProductItemBundle();
}

// On clicking on an add to cart button under a product list
function clickProductsListAddToCartHandler() {
  event.preventDefault();
  addToCartFromProductsList();
}

// On clicking on an add to cart button at the end of the product selector
function clickProductsSelectorAddToCartHandler() {
  event.preventDefault();
  addToCartFromProductsSelector();
}

// On clicking on an add to cart button at the end of the bundle selector
function clickBundleBuilderAddToCartHandler() {
  event.preventDefault();
  addToCartFromBundleBuilder();
}

/**
 * SNIPPET - ITEM PRODUCT 1 (BUNDLE)
 */

// On clicking on a product bundle item not in the bundle builder
function clickItemBundleInCollectionHandler() {
  selectBundleItem();
  redirectBundle();
}

// On clicking on a product bundle item in the bundle builder
function clickItemBundleInBuilderHandler() {
  selectBundleItem();
  enableBundlesButton();
  updateBundlesButton();
}

// Selects an item product bundle
function selectBundleItem() {
  var target = event.currentTarget,
      itemProduct = target.closest('.item-product'),
      selectedItemProduct = itemProduct.closest('.block').querySelector('.item-product.selected');

  event.preventDefault();
  if (selectedItemProduct !== null) selectedItemProduct.classList.remove('selected');
  itemProduct.classList.add('selected');
}

// Redirects to the selected bundle
function redirectBundle() {
  var target = event.currentTarget,
      itemProduct = target.closest('.item-product'),
      productUrl = itemProduct.dataset.productUrl;
  
  window.location.href = productUrl;
}

// Activates the cta of a bundles collection
function enableBundlesButton() {
  document.querySelectorAll('[data-action="redirect-bundle"]').forEach((element) => {
    element.removeAttribute('disabled');
  });
}

// Updates the cta of a bundles collection
function updateBundlesButton() {
  var target = event.currentTarget,
      itemProduct = target.closest('.item-product'),
      productPrice = parseInt(itemProduct.dataset.variantPrice),
      productPriceFormatted = Shopify.formatMoney(productPrice, window.theme.moneyFormat), // or: convertToPriceFormat(productPrice),
      productUrl = itemProduct.dataset.productUrl;

  document.querySelectorAll('[data-action="redirect-bundle"]').forEach((element) => {
    var buttonPrice = element.querySelector('.button-price');
    
    element.setAttribute('href', productUrl);
    
    if (buttonPrice !== null) {
      buttonPrice.setAttribute('data-total-price', productPrice);
      buttonPrice.querySelector('.button-price-value').textContent = productPriceFormatted;
      buttonPrice.classList.remove('hidden');
    }
  });
}

/**
 * SNIPPET - ITEM PRODUCT 2 (SELECTOR)
 */

// On clicking the - button of the quantity in a product selector item in the default context 
function clickProductItemSubQuantityHandler() {
  event.preventDefault();
  subQuantity();
  hideProductQuantity();
  deleteSummaryItem();    
  updateSubscriptionPrices();
  disableAddToCartButton();
  updateAddToCartButton();
  updateNextButton();
}

// On clicking the + button of the quantity in a product selector item in the default context 
function clickProductItemAddQuantityHandler() {
  event.preventDefault();
  addQuantity();
  addSummaryItem();
  updateSubscriptionPrices();    
  showAddToCartSection();
  enableAddToCartButton();
  updateAddToCartButton();
  updateNextButton();
} 

// On clicking on the - button of the quantity in a product selector item in the bundle builder context
function clickProductItemBundleBuilderSubQuantityHandler() {
  event.preventDefault();
  subQuantity();
  hideProductQuantity();
  deleteSummaryItem();
  deleteStepProgressionItem();
  checkSelectorButtons();
}

// On clicking on the + button of the quantity in a product selector item in the bundle builder context
function clickProductItemBundleBuilderAddQuantityHandler() {
  event.preventDefault();
  addQuantity();
  addSummaryItem();
  addStepProgressionItem(); 
  showAddToCartSection();
  checkMaximumSelection();
} 

// On clicking on the "Add" button in a product selector item where you can select several products
function clickShowProductQuantityHandler() {
  event.preventDefault();
  showProductQuantity();
} 

// On clicking on the "Add" button in a product selector item where you can only select one product
function clickSelectProductHandler() {
  event.preventDefault();
  chooseSelectorProduct();
  updateSubscriptionPrices();
  updateNextButton();
}

// Hides the quantity selector
function hideProductQuantity() {
  var target = event.currentTarget,
      itemProduct = target.closest('.item-product'),
      productQuantity = itemProduct.querySelector('.product__quantity'),
      quantityItem = productQuantity.querySelector('.product__quantity-value'),
      quantityValue = parseInt(quantityItem.textContent),
      productButton = itemProduct.querySelector('.product__button');
  
  if (quantityValue <= 0 && productButton !== null) {
    productQuantity.classList.add('hidden');
    productButton.classList.remove('hidden');
  }
}

// Displays the quantity selector
function showProductQuantity() {
  var target = event.currentTarget,
      itemProduct = target.closest('.item-product'),
      productButton = itemProduct.querySelector('.product__button'),
      productQuantity = itemProduct.querySelector('.product__quantity'),
      addButton = productQuantity.querySelector('.button--quantity-add');
  
  productButton.classList.add('hidden');
  productQuantity.classList.remove('hidden');
  addButton.click();
}

// Deletes a summary item
function deleteSummaryItem() {
  var target = event.currentTarget,
      sectionPage = target.closest('.section__page'),
      selectorSummaries = document.querySelectorAll('.selector-summary'),          
      nbItemsSelectedTexts = document.querySelectorAll('.nb-items-selected'),
      nbItemsSelectedValue = 0,      
      itemProduct = target.closest('.item-product'),
      itemHandle = itemProduct.dataset.itemHandle,
      step = parseInt(itemProduct.querySelector('.product__quantity-wrapper').getAttribute('data-step'));

  if (isNaN(step)) step = 1;

  selectorSummaries.forEach((element) => {
    var nbItemsSelected = parseInt(element.getAttribute('data-nb-items-selected')),
        newNbItemsSelected = nbItemsSelected - step,
        selectedSlots = element.querySelectorAll('.summary-item[data-product-handle="' + itemHandle + '"]'),
        selectedSlot = selectedSlots[selectedSlots.length - 1];
      
    // Deletes a summary item
    if (selectedSlot !== null) {
      if (!selectedSlot.classList.contains('last')) {
        var lastElement = element.querySelector('.summary-item.last');
        if (lastElement !== null) lastElement.classList.remove('last');  
      }   
      selectedSlot.remove();    
    }
    if (newNbItemsSelected == 0) element.closest('.block').setAttribute('data-hide-on-load', true);

    // Updates the order of the summary items
    element.querySelectorAll('.summary-item').forEach((element, index) => {
      element.setAttribute('data-summary-number', index + 1);
      element.style.setProperty('--z-index', index);
    });
    
    // Updates the number of selected items
    element.setAttribute('data-nb-items-selected', newNbItemsSelected);    
    nbItemsSelectedValue = newNbItemsSelected;
  });

  // Updates the number of selected items
  if (selectorSummaries.length > 0) {
    nbItemsSelectedTexts.forEach((element) => {
      element.textContent = nbItemsSelectedValue;
      if (nbItemsSelectedValue == 0) element.closest('.block').setAttribute('data-hide-on-load', true);
    });
  }
}

// Adds a summary item
function addSummaryItem() {
  var target = event.currentTarget,
      sectionPage = target.closest('.section__page'),
      selectorSummaries = document.querySelectorAll('.selector-summary'),       
      nbItemsSelectedTexts = document.querySelectorAll('.nb-items-selected'),
      nbItemsSelectedValue = 0,
      itemProduct = target.closest('.item-product'),
      step = parseInt(itemProduct.querySelector('.product__quantity-wrapper').getAttribute('data-step'));

  if (isNaN(step)) step = 1;

  selectorSummaries.forEach((element) => {
    var nbItemsMax = parseInt(element.getAttribute('data-nb-items-max')),
        nbItemsSelected = parseInt(element.getAttribute('data-nb-items-selected')),
        newNbItemsSelected = nbItemsSelected + step,
        slots = element.querySelectorAll('.summary-item'),
        nbSlots = slots.length,
        newSlot = document.createElement('span');
    
    newSlot.setAttribute('class', 'summary-item');
    newSlot.setAttribute('data-summary-number', nbSlots + 1);
    newSlot.setAttribute('style', '--z-index: ' + nbSlots + ';');

    // Adds a summary item
    element.querySelector('.selector-summary--inner').appendChild(newSlot);
    element.closest('.block').setAttribute('data-hide-on-load', false);
    
    // Adds the colour and attributes of a summary item 
    var slots = element.querySelectorAll('.summary-item'),
        selectedSlot = slots[slots.length - 1];

    if (selectedSlot !== null) {
      if (nbItemsMax > 0 && nbSlots >= nbItemsMax) selectedSlot.classList.add('last');
      
      selectedSlot.classList.add('selected');
      selectedSlot.style.backgroundColor = itemProduct.getAttribute('data-product-color-1');
      selectedSlot.style.backgroundImage = 'url(' + itemProduct.querySelector('.item__image').querySelector('img').getAttribute('src') + ')';
      selectedSlot.setAttribute('data-product-handle', itemProduct.dataset.itemHandle);
      selectedSlot.setAttribute('data-variant-id', itemProduct.dataset.variantId);
      selectedSlot.setAttribute('data-variant-sku', itemProduct.dataset.variantSku);
      selectedSlot.setAttribute('data-product-title', itemProduct.dataset.productTitle);
    }
    
    // Updates the number of selected items
    element.setAttribute('data-nb-items-selected', newNbItemsSelected);
    nbItemsSelectedValue = newNbItemsSelected;
  });

  // Updates the number of selected items
  if (selectorSummaries.length > 0) {
    nbItemsSelectedTexts.forEach((element) => {
      element.textContent = nbItemsSelectedValue;
      element.closest('.block').setAttribute('data-hide-on-load', false);
    });
  }
}

// Deletes a progression item
function deleteStepProgressionItem() {
  var target = event.currentTarget,
      sectionPage = target.closest('.section__page'),
      selectorStepProgressions = document.querySelectorAll('.selector-step-progression'),          
      nbItemsSelectedTexts = document.querySelectorAll('.nb-items-selected'),
      nbItemsSelectedValue = 0,      
      itemProduct = target.closest('.item-product'),
      itemHandle = itemProduct.dataset.itemHandle,
      itemTags = itemProduct.dataset.productTags;

  selectorStepProgressions.forEach((element) => {
    var nbItemsSelected = parseInt(element.getAttribute('data-nb-items-selected')),
        step = parseInt(element.getAttribute('data-step')),
        newNbItemsSelected = nbItemsSelected - step,
        selectedSlots = element.querySelectorAll('.step-progression-item[data-product-handle="' + itemHandle + '"]'),
        selectedSlot = selectedSlots[selectedSlots.length - 1],
        tag = element.getAttribute('data-tag'),
        updateBehavior = element.getAttribute('data-update-behavior'),
        nbCatItemsSelectedText = element.querySelector('.nb-cat-items-selected');

    if (itemTags.indexOf(tag) != -1 || tag == 'all') {
      if (selectedSlot !== null) {
        if (updateBehavior == 'progress') {
          // Removes the slot and add an empty one at the end
          var stepNumber = element.querySelectorAll('.step-progression-item').length + 1,
              selectorStepProgressionInner = element.querySelector('.selector-step-progression--inner'),
              stepProgressionItemHtml = document.createElement('span');
          
          stepProgressionItemHtml.setAttribute('class', 'step-progression-item');
          stepProgressionItemHtml.setAttribute('data-step-number', stepNumber);   
          stepProgressionItemHtml.setAttribute('style', '--z-index: ' + stepNumber + ';');                 
          selectedSlot.remove();
          selectorStepProgressionInner.appendChild(stepProgressionItemHtml);
  
          // Updates their "z-index" property
          updateStepProgressionItemsOrder(element);
        } else {      
          // Removes the colour and attributes of a progress item      
          selectedSlot.classList.remove('selected');
          selectedSlot.style.background = element.dataset.colorBg;
          selectedSlot.removeAttribute('data-product-handle');
          selectedSlot.removeAttribute('data-variant-id');
          selectedSlot.removeAttribute('data-variant-sku');
          selectedSlot.removeAttribute('data-product-title');
        }
      }

      // Updates the number of selected items per category / tag
      if (nbCatItemsSelectedText !== null) {
        var oldNbCatItemsSelected = parseInt(nbCatItemsSelectedText.textContent),
            newNbCatItemsSelected = oldNbCatItemsSelected - step;
  
        nbCatItemsSelectedText.textContent = newNbCatItemsSelected;
      }
  }
    
    // Updates the number of selected items
    element.setAttribute('data-nb-items-selected', newNbItemsSelected);
    nbItemsSelectedValue = newNbItemsSelected;
  });

  // Updates the number of selected items
  if (selectorStepProgressions.length > 0) {
    nbItemsSelectedTexts.forEach((element) => {
      element.textContent = nbItemsSelectedValue;
    });
  }
}

// Adds a progression item
function addStepProgressionItem() {
  var target = event.currentTarget,
      sectionPage = target.closest('.section__page'),
      selectorStepProgressions = document.querySelectorAll('.selector-step-progression'),       
      nbItemsSelectedTexts = document.querySelectorAll('.nb-items-selected'),
      nbItemsSelectedValue = 0,
      itemProduct = target.closest('.item-product'),
      itemTags = itemProduct.dataset.productTags;

  selectorStepProgressions.forEach((element) => {
    var nbItemsSelected = parseInt(element.getAttribute('data-nb-items-selected')),
        step = parseInt(element.getAttribute('data-step')),
        newNbItemsSelected = nbItemsSelected + step,
        selectedSlot = element.querySelector('.step-progression-item:not(.selected)'),
        tag = element.getAttribute('data-tag'),
        updateBehavior = element.getAttribute('data-update-behavior'),
        selectedSlotBackgroundColor = 'var(--accent-color)',
        nbCatItemsSelectedText = element.querySelector('.nb-cat-items-selected');

    if (itemTags.indexOf(tag) != -1 || tag == 'all') {
      // Adds colour and attributes to a progress item
      if (selectedSlot !== null) {
        if (updateBehavior == 'slot') selectedSlotBackgroundColor = itemProduct.getAttribute('data-product-color-1');
        selectedSlot.classList.add('selected');
        selectedSlot.style.background = selectedSlotBackgroundColor;
        selectedSlot.setAttribute('data-product-handle', itemProduct.dataset.itemHandle);
        selectedSlot.setAttribute('data-variant-id', itemProduct.dataset.variantId);
        selectedSlot.setAttribute('data-variant-sku', itemProduct.dataset.variantSku);
        selectedSlot.setAttribute('data-product-title', itemProduct.dataset.productTitle);
      }      

      // Updates the number of selected items per category / tag
      if (nbCatItemsSelectedText !== null) {
        var oldNbCatItemsSelected = parseInt(nbCatItemsSelectedText.textContent),
            newNbCatItemsSelected = oldNbCatItemsSelected + step;
  
        nbCatItemsSelectedText.textContent = newNbCatItemsSelected;
      }
    }
    
    // Updates the number of selected items
    element.setAttribute('data-nb-items-selected', newNbItemsSelected);
    nbItemsSelectedValue = newNbItemsSelected;
  });

  // Updates the number of selected items
  if (selectorStepProgressions.length > 0) {
    nbItemsSelectedTexts.forEach((element) => {
      element.textContent = nbItemsSelectedValue;
    });
  }
}

// Disables the "+" and "Add" buttons in a product selector item
function disableAddButtons(sectionPage) { 
  var addButtons = sectionPage.querySelectorAll('.button--quantity-add'),
      productButtons = sectionPage.querySelectorAll('.button[data-action="show-product-quantity"]');
  
  addButtons.forEach((element) => {
    element.setAttribute('disabled', 'disabled');
  });
  
  productButtons.forEach((element) => {
    element.setAttribute('disabled', 'disabled');
  });
}

// Enables the "+" and "Add" buttons in a product selector item
function enableAddButtons(sectionPage) {
  var addButtons = sectionPage.querySelectorAll('.button--quantity-add[disabled="disabled"]'),
      productButtons = sectionPage.querySelectorAll('.button[data-action="show-product-quantity"][disabled]');
  
  addButtons.forEach((element) => {
    if (!element.classList.contains('sold-out')) element.removeAttribute('disabled');
  });
  
  productButtons.forEach((element, index) => {
    var addButton = addButtons[index];
    
    if (!addButton.classList.contains('sold-out')) element.removeAttribute('disabled');
  });
}

// Displays the fixed section containing the cta on mobile
function showAddToCartSection() {
  if (window.innerWidth < 1025) {
    var section = document.querySelector('.section--footer-fixed');
    
    if (section !== null) section.style.display = 'block';
  }
}

// Disables the button to add a list of products to the cart
function disableAddToCartButton() { 
  var target = event.currentTarget,
      sectionPage = target.closest('.section__page'),
      addToCartButtons = sectionPage.querySelectorAll('[data-action="add-to-cart-products-list"]'),
      itemsProduct = sectionPage.querySelectorAll('.item-product'),
      disableButton = true;

  if (addToCartButtons.length == 0) addToCartButtons = document.querySelectorAll('[data-action="add-to-cart-products-selector"]');
  
  if (addToCartButtons.length > 0) {
    itemsProduct.forEach((element) => {
      var productQuantity = element.querySelector('.product__quantity'),
          quantityItem = productQuantity.querySelector('.product__quantity-value'),
          quantityValue = parseInt(quantityItem.textContent);
      
      if (quantityValue > 0) disableButton = false;
    });

     // TO CHECK FOR BUNDLES*
    if (target.closest('.item-product[data-item-template-suffix="bundle-product"]') !== null) disableButton = true;
    
    if (disableButton) {
      addToCartButtons.forEach((element) => {
        if (element.getAttribute('data-disabled') == 'true') element.setAttribute('disabled', 'disabled');
      });
    }
  }
}

// Enables the button to add a list of products to the cart
function enableAddToCartButton() {
  var target = event.currentTarget,
      sectionPage = target.closest('.section__page'),
      addToCartButtons = sectionPage.querySelectorAll('[data-action="add-to-cart-products-list"]');

  if (addToCartButtons.length == 0) addToCartButtons = document.querySelectorAll('[data-action="add-to-cart-products-selector"]');

  if (addToCartButtons.length > 0) {
    addToCartButtons.forEach((element) => {
      element.removeAttribute('disabled');
    });
  }
}

// Updates the price in the general button to add to cart
function updateAddToCartButton() { 
  var target = event.currentTarget,
      sectionPage = target.closest('.section__page'),
      addToCartButtons = sectionPage.querySelectorAll('[data-action="add-to-cart-products-list"]');

  if (addToCartButtons.length == 0) addToCartButtons = document.querySelectorAll('[data-action="add-to-cart-products-selector"]');

  addToCartButtons.forEach((element) => {
    var buttonPrice = element.querySelector('.button-price'),
        itemProduct = target.closest('.item-product'),
        itemProductPrice = parseInt(itemProduct.dataset.variantPrice),
        itemProductPriceCompare = parseInt(itemProduct.dataset.variantCompareAtPrice),
        step = parseInt(target.closest('.product__quantity-wrapper').dataset.step);
  
    if (element !== null && buttonPrice !== null) {
      var totalPrice = parseInt(buttonPrice.getAttribute('data-total-price')),
          totalPriceCompare = parseInt(buttonPrice.getAttribute('data-total-price-compare')),
          newTotalPrice = totalPrice,
          newTotalPriceCompare = totalPriceCompare;
      
      if (target.classList.contains('button--quantity-add')) {
        newTotalPrice = totalPrice + (itemProductPrice * step);
        newTotalPriceCompare = totalPriceCompare + (itemProductPriceCompare * step);
      } else if (target.classList.contains('button--quantity-sub')) {
        newTotalPrice = totalPrice - (itemProductPrice * step);
        newTotalPriceCompare = totalPriceCompare - (itemProductPriceCompare * step);
      }

      var newTotalPriceFormatted = Shopify.formatMoney(newTotalPrice, window.theme.moneyFormat), // or: convertToPriceFormat(newTotalPrice);
          newTotalPriceCompareFormatted = Shopify.formatMoney(newTotalPriceCompare, window.theme.moneyFormat); // or: convertToPriceFormat(newTotalPriceCompare);
      
      buttonPrice.setAttribute('data-total-price', newTotalPrice);
      buttonPrice.setAttribute('data-total-price-compare', newTotalPriceCompare);
      buttonPrice.querySelector('.button-price-value').textContent = newTotalPriceFormatted;
      newTotalPriceCompare > newTotalPrice ? buttonPrice.querySelector('.button-original-price-value').textContent = newTotalPriceCompareFormatted : buttonPrice.querySelector('.button-original-price-value').textContent = '';
      newTotalPrice > 0 ? buttonPrice.classList.remove('hidden') : buttonPrice.classList.add('hidden');
    }
  });
}

// Disables the button to go to the next step of the selector
function disableNextButton(sectionPage) { 
  var buttonNextStep = sectionPage.querySelectorAll('[data-action="selector-next-step"]');

  if (buttonNextStep.length == 0) buttonNextStep = document.querySelectorAll('[data-action="selector-next-step-add-to-cart"]');

  if (buttonNextStep.length > 0) {
    buttonNextStep.forEach((element) => {
      element.setAttribute('disabled', 'disabled');
    });
  } else {
    var buttonsNextStep = document.querySelectorAll('[data-action="selector-next-step"]');

    buttonsNextStep.forEach((element) => {
      if (element.closest('.section__page').classList.contains('swiper-slide-active')) element.setAttribute('disabled', 'disabled');
    });
  }
}

// Enables the button to go to the next step of the selector
function enableNextButton(sectionPage) { 
  var buttonNextStep = sectionPage.querySelectorAll('[data-action="selector-next-step"]');

  if (buttonNextStep.length == 0) buttonNextStep = document.querySelectorAll('[data-action="selector-next-step-add-to-cart"]');

  if (buttonNextStep.length > 0) {
    buttonNextStep.forEach((element) => {
      element.removeAttribute('disabled');
      //scrollToElement(element);
    });
  } else {
    var buttonsNextStep = document.querySelectorAll('[data-action="selector-next-step"]');

    buttonsNextStep.forEach((element) => {
      if (element.closest('.section__page').classList.contains('swiper-slide-active')) element.removeAttribute('disabled');
    });
  }
}

// Updates the price in the button to move to the next step in the selector // TO CHECK FOR BUNDLES
function updateNextButton() { 
  var target = event.currentTarget,
      buttonsNextStep = document.querySelectorAll('[data-action="selector-next-step"], [data-action="add-to-cart-bundle-builder"], [data-action="selector-next-step-add-to-cart"]');

  if (buttonsNextStep.length > 0) {
    if (!isCurrentStep('addons')) {
      var itemVariant = target.closest('.item-variant'),
          itemVariantFirst = document.querySelector('.list-variants').querySelectorAll('.item-variant')[0],
          itemVariantLast = document.querySelector('.list-variants').querySelectorAll('.item-variant')[1];

      if (itemVariant === null) itemVariant = itemVariantLast;

      var itemVariantFirstPrice = parseInt(itemVariantFirst.dataset.variantPrice),
          itemVariantLastPrice = parseInt(itemVariantLast.dataset.variantPrice),
          priceDifference = itemVariantLastPrice - itemVariantFirstPrice,
          itemVariantFirstPriceCompare = parseInt(itemVariantFirst.dataset.variantCompareAtPrice),
          itemVariantLastPriceCompare = parseInt(itemVariantLast.dataset.variantCompareAtPrice),
          priceDifferenceCompare = itemVariantLastPriceCompare - itemVariantFirstPriceCompare;
    } else if (isCurrentStep('addons')) {
      var itemProduct = target.closest('.item-product'),
          itemProductPrice = parseInt(itemProduct.dataset.variantPrice),
          itemProductPriceCompare = parseInt(itemProduct.dataset.variantCompareAtPrice),
          step = parseInt(target.closest('.product__quantity-wrapper').dataset.step);
    } else {
      
    }

    buttonsNextStep.forEach((element) => {
      var buttonPrice = element.querySelector('.button-price'),
          totalPrice = parseInt(buttonPrice.getAttribute('data-total-price')),
          totalPriceCompare = parseInt(buttonPrice.getAttribute('data-total-price-compare')),
          newTotalPrice = totalPrice,
          newTotalPriceCompare = totalPriceCompare;

      if (buttonPrice !== null) {
        if (!isCurrentStep('addons')) {
          if (itemVariant.dataset.variantId == itemVariantFirst.dataset.variantId) {
            newTotalPrice = totalPrice - priceDifference;
            newTotalPriceCompare = totalPriceCompare - priceDifferenceCompare;
          } else if (itemVariant.dataset.variantId == itemVariantLast.dataset.variantId) {
            newTotalPrice = totalPrice + priceDifference;
            newTotalPriceCompare = totalPriceCompare + priceDifferenceCompare;
          }
        } else if (isCurrentStep('addons')) {       
          if (target.classList.contains('button--quantity-add')) {
            newTotalPrice = totalPrice + (itemProductPrice * step);
            newTotalPriceCompare = totalPriceCompare + (itemProductPriceCompare * step);
          } else if (target.classList.contains('button--quantity-sub')) {
            newTotalPrice = totalPrice - (itemProductPrice * step);
            newTotalPriceCompare = totalPriceCompare - (itemProductPriceCompare * step);
          }
        } else {
          
        }
        
        var newTotalPriceFormatted = Shopify.formatMoney(newTotalPrice, window.theme.moneyFormat), // or: convertToPriceFormat(newTotalPrice);
            newTotalPriceCompareFormatted = Shopify.formatMoney(newTotalPriceCompare, window.theme.moneyFormat); // or: convertToPriceFormat(newTotalPriceCompare);
        
        buttonPrice.setAttribute('data-total-price', newTotalPrice);
        buttonPrice.setAttribute('data-total-price-compare', newTotalPriceCompare);
        buttonPrice.querySelector('.button-price-value').textContent = newTotalPriceFormatted;
        newTotalPriceCompare > newTotalPrice ? buttonPrice.querySelector('.button-original-price-value').textContent = newTotalPriceCompareFormatted : buttonPrice.querySelector('.button-original-price-value').textContent = '';
      }
    });
  }
}

// Displays a popup to suggest the custom option
function showUpgradePopup(sectionPage) { 
  var listVariantsBundle = sectionPage.querySelector('.list-variants-bundle'),
      itemsVariant = listVariantsBundle.querySelectorAll('.item-variant-bundle'),
      itemVariantSelected = listVariantsBundle.querySelector('.item-variant-bundle.selected'),
      itemVariantSelectedSku = itemVariantSelected.dataset.variantSku;

   // TO CHECK FOR BUNDLES
  if (itemsVariant.length > 1 && itemVariantSelectedSku.indexOf('CUSTOM') == -1) openModalWithId('modal-upgrade-bundle');
}

// Checks whether to display or reactivate buttons
function checkSelectorButtons() {
  var target = event.currentTarget,
      sectionPage  = target.closest('.section__page'),
      selectorStepProgression = document.querySelector('.selector-step-progression'),
      nbItemsMax = parseInt(selectorStepProgression.getAttribute('data-nb-products')),
      nbItemsSelected = parseInt(selectorStepProgression.getAttribute('data-nb-items-selected'));

  if (selectorStepProgression === null) {
    var selectorSummary = document.querySelector('.selector-summary'),
        step = parseInt(target.closest('.product__quantity-wrapper').getAttribute('data-step')),
        nbItemsMax = parseInt(selectorSummary.getAttribute('data-nb-items-max')),
        nbItemsMax = nbItemsMax * step,
        nbItemsSelected = parseInt(selectorSummary.getAttribute('data-nb-items-selected'));
  }
  
  // If the number of selected items is less than the maximum number of selectable items
  if (nbItemsSelected < nbItemsMax) {
    enableAddButtons(sectionPage);
    disableAddToCartButton(target);
    disableNextButton(sectionPage);
  }
}

// Checks if the maximum number of selectable items has been reached
function checkMaximumSelection() {
  var target = event.currentTarget,
      sectionPage  = target.closest('.section__page'),
      selectorStepProgression = document.querySelector('.selector-step-progression'),
      nbItemsMax = parseInt(selectorStepProgression.getAttribute('data-nb-products')),
      nbItemsSelected = parseInt(selectorStepProgression.getAttribute('data-nb-items-selected'));

  if (selectorStepProgression === null) {
    var selectorSummary = document.querySelector('.selector-summary'),
        step = parseInt(target.closest('.product__quantity-wrapper').getAttribute('data-step')),
        nbItemsMax = parseInt(selectorSummary.getAttribute('data-nb-items-max')),
        nbItemsMax = nbItemsMax * step,
        nbItemsSelected = parseInt(selectorSummary.getAttribute('data-nb-items-selected'));
  }
  
  // If the number of selected items equals (or exceeds) the maximum number of selectable items
  if (nbItemsSelected >= nbItemsMax) {
    disableAddButtons(sectionPage);
    enableAddToCartButton(target);
    enableNextButton(sectionPage);
    showUpgradePopup(sectionPage);
  }
}

// Selects a product in the selector
function chooseSelectorProduct() {
  var target = event.currentTarget,
      sectionPage = target.closest('.section__page'),
      itemProduct = target.closest('.item-product');
  
  if (itemProduct.classList.contains('selected')) {
    unSelectProduct(itemProduct);
    deleteSummaryItem();
    disableNextButton(sectionPage);
  } else {  
    selectProduct(itemProduct);
    addSummaryItem();
    enableNextButton(sectionPage);
  }
}

// Deselects one product and activates the others
function unSelectProduct(itemProduct) {
  var target = event.currentTarget,
      sectionSnippet = itemProduct.closest('.block'),
      buttonText = target.dataset.buttonText;
  
  sectionSnippet.querySelectorAll('.item-product').forEach((element) => {
    element.classList.remove('disabled');
  });
  itemProduct.classList.remove('selected');
  target.querySelector('span').textContent = buttonText;
}

// Selects one product and disables the others
function selectProduct(itemProduct) {
  var target = event.currentTarget,
      sectionSnippet = itemProduct.closest('.block'),
      buttonText = window.languages.addedProductButton,
      selectedItemProduct = sectionSnippet.querySelector('.item-product.selected');

  if (selectedItemProduct !== null) selectedItemProduct.querySelector('[data-action="select-product"]').click();
  sectionSnippet.querySelectorAll('.item-product').forEach((element) => {
    element.classList.add('disabled');  
    element.classList.remove('selected');
  });
  itemProduct.classList.remove('disabled');
  itemProduct.classList.add('selected');
  target.querySelector('span').textContent = buttonText;
}